"use client";

import React from "react";
import { BookOpen, Shield, Stethoscope, ArrowRight, Droplet } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const tiers = [{
  id: "01",
  title: "Quality Education",
  description: "Empowering the next generation through school construction, teacher training, and essential learning materials for remote villages.",
  icon: BookOpen
}, {
  id: "02",
  title: "Clean Water Access",
  description: "Implementing sustainable solar-powered well systems and filtration technology to provide safe drinking water to thousands.",
  icon: Droplet
}, {
  id: "03",
  title: "Community Health",
  description: "Mobile clinics and local health centers providing critical medical care, vaccinations, and maternal health support services.",
  icon: Stethoscope
}];
export default function OurCoreInitiatives() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236959" id="our-core-initiatives" className="bg-background text-foreground py-24 px-4 md:px-8 lg:px-16 overflow-hidden" ref={ref}>
      <div className="max-w-7xl mx-auto">
        <div className={`mb-16 md:mb-24 transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-sm font-default tracking-widest text-chart-2 uppercase mb-4">
            Our Mission in Action
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight max-w-3xl">
            Our Core Initiatives
          </h3>
          <div className="h-1 w-24 bg-chart-2 mt-8"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {tiers.map((tier, i) => {
          const Icon = tier.icon;
          return <div key={tier.id} data-index={i} className={`transition-all duration-1000 delay-${i * 200} transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <Card className="relative h-full overflow-hidden group bg-card/50 backdrop-blur-md border border-border rounded-lg p-8 md:p-10 transition-all duration-500 hover:-translate-y-2 hover:border-chart-2 hover:shadow-xl z-10 flex flex-col justify-between">
                  {}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-transparent group-hover:from-chart-2/5 transition-all duration-500 pointer-events-none z-0" />

                  {}
                  <div className="absolute -bottom-8 -right-4 text-[12rem] leading-none font-default font-bold text-chart-2/5 select-none pointer-events-none transition-transform duration-700 group-hover:scale-110 group-hover:-translate-x-4 group-hover:-translate-y-4 z-0">
                    {tier.id}
                  </div>

                  <div className="relative z-10">
                    <div className="mb-8 inline-flex items-center justify-center p-4 border border-chart-2/20 bg-white shadow-sm rounded-lg group-hover:border-chart-2 group-hover:scale-110 transition-all duration-500">
                      <Icon className="w-8 h-8 text-chart-2" strokeWidth={1.5} />
                    </div>

                    <h4 className="text-2xl font-default font-bold text-foreground mb-4 group-hover:text-chart-2 transition-colors duration-300">
                      {tier.title}
                    </h4>

                    {}
                    <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-in-out">
                      <div className="overflow-hidden">
                        <p className="text-muted-foreground font-default transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500 delay-100 pb-6">
                          {tier.description}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="relative z-10 mt-auto pt-4 border-t border-border/50 opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 delay-200">
                    <Button variant="link" className="p-0 h-auto text-chart-2 hover:text-chart-1 hover:no-underline group/btn">
                      <span className="font-default font-semibold tracking-wide uppercase text-sm">Learn More</span>
                      <ArrowRight className="w-4 h-4 ml-2 transform group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}